export const PAGINATE = 'PAGINATE';

export function paginate(page, qs, e) {
    return {
        type: PAGINATE,
        payload: {
            page: page,
            requestType: PAGINATE,
            requestStatus: 'MAKING_REQUEST',
            queryString: qs
        },
        meta: {
            event: e
        }
    };
}
